import * as React from 'react';
import Spinner from 'react-bootstrap/Spinner';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /** The icon from the material icons library or a custom react component */
    icon : string | React.ReactNode,
    /** Classname to be appended to the icon */
    iconClassName? : string,
    /** Custom style object to be injected into the icon */
    iconStyles? : any,
    /** What the icon displays */
    children : any,
    /** Append a class to the wrapping span of children */
    contentWrapperClassName? : string,
    /** Custom class for the <button> element */
    buttonClassName? : string,
    /** Controls when the icon will turn to a loading spinner */
    showSpinner? : boolean | any,
    /** Switches icon to the left side of button */
    inverted? : boolean,
    /** Text to display when showSpinner=true */
    spinnerText? : string,
    /** Text to display when hovering over component / This will replace the children prop on hover if activated */
    hoverText?: string;
    ref?: any
}

const IconButton: React.FunctionComponent<IconButtonProps> = (props: IconButtonProps) => {
    const { icon, iconClassName, iconStyles, contentWrapperClassName, showSpinner, spinnerText, hoverText } = props;
    const [isHovering, setIsHovering] = React.useState(false);

    const handleMouseEnter = () => {
        setIsHovering(true);
    }

    const handleMouseLeave = () => {
        setIsHovering(false);
    }

    const buttonProps = (({ 
        icon, 
        iconClassName, 
        iconStyles, 
        contentWrapperClassName, 
        showSpinner, 
        buttonClassName,
        inverted,
        spinnerText,
        hoverText,
        ...p 
    }) => p)(props);
    return (
        <button 
            disabled={showSpinner || props.disabled}
            className={`btn icon-button ${props.buttonClassName}`} 
            onClick={props.onClick} 
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            name={props.name}
            ref={props.ref}
            {...buttonProps}
        >
            {
            props.inverted&&(
                showSpinner && spinnerText 
                ? spinnerText 
                : 
                <span className={contentWrapperClassName}>
                    {isHovering
                        ?hoverText
                            ?hoverText
                            :props.children
                        :props.children
                    }
                </span>
                )
            }
            {
                showSpinner
                ?<Spinner size="sm" animation="border" className="mr-1" />
                :typeof icon === "string" ? <i style={{...iconStyles}} className={`material-icons p ${iconClassName}`}>{icon}</i> : icon
            }
            {!props.inverted&&(showSpinner && spinnerText ? spinnerText :<span className={contentWrapperClassName || "no-wrap"}>{props.children}</span>)}
        </button>
    );
}

IconButton.defaultProps = {
    iconClassName : "",
    children : null,
    iconStyles : {},
    contentWrapperClassName : "",
    buttonClassName : "btn btn-outline-secondary",
    showSpinner : false,
    inverted : false,
    spinnerText : ""
}

export default IconButton;